import { constants } from 'quasar-pilot-core/src/lib/constants';

constants.DEFAULT_LOCATION = 1;
constants.DEFAULT_DELIVERY_METHOD = 1;
constants.DEFAULT_PAYMENT_METHOD = 1;
constants.CATEGORY_OFFER_ID = 8;

constants.SESSION_COOKIE_USER_ID = 'userUid';
constants.SESSION_COOKIE_LOCATION_ID = 'locationUid';

constants.LOCATIONS = [{
  name: 'Akureyri',
  code: 'ak',
  address: 'Ráðhústorg 3',
  address2: '600 Akureyri',
  phoneNumber: '461-4242',
  closedMondays: true,
  openingHours1: '11:30 - 13:30 og á kvöldin 17:30 - 21:00',
  openingHours2: '17:30 - 21:00',
  image: '/images/loc1.png',
  orderUrl: 'https://www.dineout.is/restaurant?id=98&isolation=true&lng=is',
},
{
  name: 'Reykjavík',
  code: 'rvk',
  address: 'Vesturgata 12',
  address2: '101 Reykjavík',
  phoneNumber: '583-4242',
  closedMondays: true,
  openingHours1: '17:00 - 21:00',
  openingHours2: '17:00 - 22:00',
  image: '/images/loc2.jpg',
  orderUrl: 'https://www.dineout.is/restaurant?id=98&isolation=true&lng=is',
},
];

export default constants;
